"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var phosphor_react_1 = require("phosphor-react");
var react_1 = __importStar(require("react"));
var themes_1 = require("../../themes");
var usePopOutOfOverflowHiddenParent_1 = require("../../utils/usePopOutOfOverflowHiddenParent");
var Typo_1 = require("../Typo");
var styled_1 = require("./styled");
/**
 * @component Renders a tooltip component with customizable text and styling.
 *
 * - The props object containing the following properties:
 * @prop {string} props.text: The text to be displayed in the tooltip.
 * @prop {'top' | 'bottom' | 'left' | 'right'} props.position: The position of the tooltip relative to the target element. Defaults to "top".
 * @prop {React.CSSProperties} props.style: Additional CSS styles to apply to the tooltip.
 * @prop {React.ReactNode} props.children: The content to be rendered inside the tooltip target element.
 * @prop {boolean} props.popOutOfOverflowHiddenParent: A boolean indicating whether the tooltip should pop out of an overflow:hidden parent element. Defaults to false.
 * @prop {boolean} props.invert: A boolean indicating whether to invert the tooltip colors. Defaults to false.
 * @prop {string} props.debug: A boolean indicating whether to enable debug mode for the tooltip. Defaults to false. only for dev use
 * @prop {string} props.presetTarget: A string indicating a preset target for the tooltip. Defaults to infoIcon.
 * @return {ReactElement} The rendered tooltip component.
 */
var Tooltip = function (_a) {
    var text = _a.text, _b = _a.position, position = _b === void 0 ? "top" : _b, style = _a.style, children = _a.children, _c = _a.popOutOfOverflowHiddenParent, popOutOfOverflowHiddenParent = _c === void 0 ? false : _c, _d = _a.invert, invert = _d === void 0 ? false : _d, _e = _a.debug, debug = _e === void 0 ? false : _e, presetTarget = _a.presetTarget;
    var _f = (0, react_1.useState)(debug ? true : false), isClicked = _f[0], setIsClicked = _f[1];
    var _g = (0, react_1.useState)(debug ? true : false), showTooltip = _g[0], setShowTooltip = _g[1];
    var targetRef = (0, react_1.useRef)(null);
    var _h = (0, usePopOutOfOverflowHiddenParent_1.usePopOutOfOverflowHiddenParent)(popOutOfOverflowHiddenParent), trackerRef = _h.trackerRef, applyFixedPos = _h.applyFixedPos, removeFixedPos = _h.removeFixedPos, fixPos = _h.fixPos;
    (0, react_1.useEffect)(function () {
        if (popOutOfOverflowHiddenParent) {
            if (showTooltip) {
                applyFixedPos();
            }
            else {
                removeFixedPos();
            }
        }
    }, [showTooltip]);
    (0, react_1.useEffect)(function () {
        setShowTooltip(debug);
    }, [debug]);
    return (react_1.default.createElement(styled_1.StyledWrapper, { ref: trackerRef, id: "wrapper" },
        react_1.default.createElement(styled_1.StyledTooltipTarget, { onMouseEnter: function () {
                if (!isClicked) {
                    setShowTooltip(true);
                }
            }, onMouseLeave: function () {
                if (!isClicked) {
                    setShowTooltip(false);
                }
            }, onClick: function () {
                setIsClicked(true), setShowTooltip(true);
            }, onBlur: function () {
                setIsClicked(false), setShowTooltip(false);
            }, ref: targetRef, tabIndex: 0 }, presetTarget === "infoIcon" ? (react_1.default.createElement(styled_1.StyledIconButton, null,
            " ",
            react_1.default.createElement(phosphor_react_1.Info, { color: invert ? themes_1.colors.white : themes_1.colors.greyColor100, size: 16, weight: showTooltip ? 'fill' : 'regular' }))) : (children)),
        showTooltip && (react_1.default.createElement(styled_1.StyledTooltipBox, { fixPos: fixPos, isOpen: showTooltip, position: position, show: showTooltip, style: style, invert: invert },
            text.split('\n').filter(Boolean).map(function (singleline, i) { return (react_1.default.createElement(Typo_1.SANS_2, __assign({}, (i !== 0 ? { style: { marginTop: '0.5rem' } } : {})), singleline)); }),
            react_1.default.createElement(styled_1.StyledArrowOutline, { position: position },
                react_1.default.createElement(styled_1.StyledArrow, { position: position, invert: invert }))))));
};
exports.Tooltip = Tooltip;
